module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Bảng điều khiển"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('el-row', {
    staticClass: "remove-margin margin-sm-top",
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 14,
      "xs": 0
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    staticClass: "margin-sm-bottom",
    attrs: {
      "span": 5,
      "xs": 24
    }
  }, [_c('el-date-picker', {
    staticClass: "width-100",
    attrs: {
      "size": "small",
      "type": "daterange",
      "range-separator": " / ",
      "format": "dd-MM-yyyy",
      "start-placeholder": "Từ ngày",
      "end-placeholder": "Đến ngày"
    },
    on: {
      "input": _vm.updateFilters
    },
    model: {
      value: (_vm.filterDateRange),
      callback: function($$v) {
        _vm.filterDateRange = $$v
      },
      expression: "filterDateRange"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5,
      "xs": 24
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.changeView
    },
    model: {
      value: (_vm.view),
      callback: function($$v) {
        _vm.view = $$v
      },
      expression: "view"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "day"
    }
  }, [_vm._v("Ngày")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "week"
    }
  }, [_vm._v("Tuần")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "month"
    }
  }, [_vm._v("Tháng")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "year"
    }
  }, [_vm._v("Năm")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin margin-top",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h2', [_vm._v("Biểu đồ biểu diễn theo thời gian")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "statistic-proportion"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "statistic-client"
    }
  })])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin margin-top",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "statistic-cod-amount"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "statistic-profit"
    }
  })])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin margin-top",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h2', [_vm._v("Biểu đồ phân bổ theo thời gian")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "statistic-total-shop"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "statistic-total-source"
    }
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "margin-lg-top",
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "statistic-carrier-pie"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "statistic-proportion-pie"
    }
  })])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin margin-top",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h2', [_vm._v("Thống kê hoạt động của người dùng")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('p', {
    staticClass: "header text-center"
  }, [_vm._v("10 Khách hàng có số lượng đơn cao nhất "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.drawAllUserHasShipment.apply(null, arguments)
      }
    }
  }, [_c('small', [_vm._v("(Xem tất cả)")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub-header text-center"
  }, [_vm._v("\n          10 Khách hàng có số lượng đơn cao nhất\n          "), (_vm.filters.start_date && _vm.filters.end_date) ? _c('span', [_vm._v(_vm._s((" từ ngày " + (_vm.formatDate(this.filters.start_date,
            'DD-MM-YYYY')) + " đến ngày " + (_vm.formatDate(this.filters.end_date, 'DD-MM-YYYY')))))]) : _c('span', [_vm._v(_vm._s(' ngày ' + _vm.formatDate(new Date(), 'DD-MM-YYYY')))])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.topUserAllShipment,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Khách hàng"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.client) ? _c('span', [_vm._v(_vm._s(scope.row.client.data.name))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tổng đơn",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("number")(scope.row.total_shipment)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Đơn thành công",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("number")(scope.row.total_success)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tỉ lệ",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("percent")((scope.row.total_success / scope.row.total_shipment) * 100, 2)))]), _vm._v(" "), _c('a', {
          staticClass: "text-blue cursor-pointer pull-right",
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.showDetailShop(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-search"
        })])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('p', {
    staticClass: "header text-center"
  }, [_vm._v("10 Khách hàng có số lượng đơn chuyển hoàn cao nhất")]), _vm._v(" "), _c('p', {
    staticClass: "sub-header text-center"
  }, [_vm._v("\n          10 Khách hàng có số lượng đơn chuyển hoàn cao nhất\n          "), (_vm.filters.start_date && _vm.filters.end_date) ? _c('span', [_vm._v(_vm._s((" từ ngày " + (_vm.formatDate(this.filters.start_date,
            'DD-MM-YYYY')) + " đến ngày " + (_vm.formatDate(this.filters.end_date, 'DD-MM-YYYY')))))]) : _c('span', [_vm._v(_vm._s(' ngày ' + _vm.formatDate(new Date(), 'DD-MM-YYYY')))])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.topUserReturnShipment,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Khách hàng"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.client) ? _c('span', [_vm._v(_vm._s(scope.row.client.data.name))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tổng đơn",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("number")(scope.row.total_shipment)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Đơn chuyển hoàn",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("number")(scope.row.total_return)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tỉ lệ",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("percent")((scope.row.total_return / scope.row.total_shipment) * 100)))])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('p', {
    staticClass: "header text-center"
  }, [_vm._v("10 quận có lượng đơn cao nhất")]), _vm._v(" "), _c('p', {
    staticClass: "sub-header text-center"
  }, [_vm._v("\n          10 quận có lượng đơn cao nhất\n          "), (_vm.filters.start_date && _vm.filters.end_date) ? _c('span', [_vm._v(_vm._s((" từ ngày " + (_vm.formatDate(this.filters.start_date,
            'DD-MM-YYYY')) + " đến ngày " + (_vm.formatDate(this.filters.end_date, 'DD-MM-YYYY')))))]) : _c('span', [_vm._v(_vm._s(' ngày ' + _vm.formatDate(new Date(), 'DD-MM-YYYY')))])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.topDistrictTopShipment,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Quận"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.name) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tổng đơn",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("number")(scope.row.total_shipment)))])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('p', {
    staticClass: "header text-center"
  }, [_vm._v("10 quận có lượng khách hàng cao nhất")]), _vm._v(" "), _c('p', {
    staticClass: "sub-header text-center"
  }, [_vm._v("\n          10 quận có lượng khách hàng cao nhất\n          "), (_vm.filters.start_date && _vm.filters.end_date) ? _c('span', [_vm._v(_vm._s((" từ ngày " + (_vm.formatDate(this.filters.start_date,
            'DD-MM-YYYY')) + " đến ngày " + (_vm.formatDate(this.filters.end_date, 'DD-MM-YYYY')))))]) : _c('span', [_vm._v(_vm._s(' ngày ' + _vm.formatDate(new Date(), 'DD-MM-YYYY')))])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.topDistrictTopUser,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Quận"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.name) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Khách hàng",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("number")(scope.row.total_user)))])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('p', {
    staticClass: "header text-center"
  }, [_vm._v("Thống kê đơn theo tỉnh thành")]), _vm._v(" "), _c('p', {
    staticClass: "sub-header text-center"
  }, [_vm._v("\n          Thống kê đơn theo tỉnh thành\n          "), (_vm.filters.start_date && _vm.filters.end_date) ? _c('span', [_vm._v(_vm._s((" từ ngày " + (_vm.formatDate(this.filters.start_date,
            'DD-MM-YYYY')) + " đến ngày " + (_vm.formatDate(this.filters.end_date, 'DD-MM-YYYY')))))]) : _c('span', [_vm._v(_vm._s(' ngày ' + _vm.formatDate(new Date(), 'DD-MM-YYYY')))])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": [].concat(_vm.matrixShipmentByCity, _vm.interprovinceShipment),
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Thời gian"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.create_time) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tỉnh thành đi"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.city_from_name ? scope.row.city_from_name : scope.row.city_from) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tỉnh thành đến"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.city_to_name ? scope.row.city_to_name : 'Liên tỉnh') + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Vận đơn",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("number")(scope.row.total_shipment)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Phí vận chuyển",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("number")(scope.row.total_location_fee / 1000)) + " k")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('p', {
    staticClass: "header text-center"
  }, [_vm._v("Thống kê đơn gửi từ tỉnh thành")]), _vm._v(" "), _c('p', {
    staticClass: "sub-header text-center"
  }, [_vm._v("\n          Thống kê đơn gửi từ tỉnh thành\n          "), (_vm.filters.start_date && _vm.filters.end_date) ? _c('span', [_vm._v(_vm._s((" từ ngày " + (_vm.formatDate(this.filters.start_date,
            'DD-MM-YYYY')) + " đến ngày " + (_vm.formatDate(this.filters.end_date, 'DD-MM-YYYY')))))]) : _c('span', [_vm._v(_vm._s(' ngày ' + _vm.formatDate(new Date(), 'DD-MM-YYYY')))])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.allShipmentFromCity,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Thời gian"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.create_time) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tỉnh thành"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.city_from) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Vận đơn",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("number")(scope.row.total_shipment)))])]
      }
    }])
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": ("Thông tin shop: " + (_vm.currentShop.shop_name)),
      "visible": _vm.detailShopModal
    },
    on: {
      "update:visible": function($event) {
        _vm.detailShopModal = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "statistic-detail-shopment-shop"
    }
  })])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Danh sách khách hàng tạo đơn",
      "visible": _vm.allUserHasShipmentModal
    },
    on: {
      "update:visible": function($event) {
        _vm.allUserHasShipmentModal = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.allUserHasShipment,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Khách hàng"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.client) ? _c('span', [_vm._v(_vm._s(scope.row.client.data.name))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tổng đơn",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("number")(scope.row.total_shipment)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Đơn thành công",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("number")(scope.row.total_success)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tỉ lệ",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("percent")((scope.row.total_success / scope.row.total_shipment) * 100, 2)))]), _vm._v(" "), _c('a', {
          staticClass: "text-blue cursor-pointer pull-right",
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.showDetailShop(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-search"
        })])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fba1707"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Dashboard.vue
// module id = 629
// module chunks = 1